import { createContext } from 'react';
export const DEFAULT_USAGE_LIMIT_DATA = {
  quantityUsed: 0,
  limit: null
};
export const DEFAULT_CONTENT_USAGE_LIMITS = {
  blogPosts: DEFAULT_USAGE_LIMIT_DATA,
  blog: DEFAULT_USAGE_LIMIT_DATA,
  sitePages: DEFAULT_USAGE_LIMIT_DATA,
  landingPages: DEFAULT_USAGE_LIMIT_DATA
};
export default /*#__PURE__*/createContext({
  contentUsageLimits: DEFAULT_CONTENT_USAGE_LIMITS,
  getUsageLimitInfoForContentTypeId: () => ({
    cannotCreateMoreContent: false,
    disabledTooltipSuffix: ''
  })
});